/* eslint-disable quotes */
import { defineComponent, h } from "vue";
import { Dialog } from '@phi/components';
import { display_set_vertex_distance } from '@frontend/ui_display';

const body = `<div class="row">
    <div class="col-sm-12 block-2-box wow fadeInUp">
        <p class="modal-title" id="vertexDistanceModalValueTitle">New distance between selected vertices:</p>
        <div class="col-sm-12 block-3-box wow fadeInUp">
            <p class="modal-body-bigger-text"> <input id="vertexDistValue" class="modal-input" autocomplete="off"></input></p>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-sm-12 block-2-box wow fadeInUp">
        <label for="vertexDistEntireBodyRadio" class="toggle">
            <div class="toggle__label">Scale entire body (not just the 2 vertices):</div>
            <input type="checkbox" class="form-check-input sr-only" id="vertexDistEntireBodyRadio"
                    name="vertexDistEntireBodyRadio" onclick="vertex_distance_dont_scale_proportionately()">
            <div class="toggle__toggler toggler">
                <div class="toggler__knob"></div>
            </div>
        </label>
    </div>
</div>

<div class="row">
    <div class="col-sm-12 block-2-box wow fadeInUp">
        <label for="vertexDistProportionalRadio" class="toggle">
            <div class="toggle__label">Scale proportionately:</div>
            <input type="checkbox" class="form-check-input sr-only" id="vertexDistProportionalRadio"
                    name="vertexDistProportionalRadio" onclick="vertex_distance_set_entire_body_status()">
            <div class="toggle__toggler toggler">
                <div class="toggler__knob"></div>
            </div>
        </label>
    </div>
</div>

<div class="row">
    <div class="col-sm-12 block-2-box wow fadeInUp">
        <label for="vertexDistFixFirstVertexRadio" class="toggle">
            <div class="toggle__label">Lock the first vertex:</div>
            <input type="checkbox" class="form-check-input sr-only" id="vertexDistFixFirstVertexRadio"
                    name="vertexDistFixFirstVertexRadio" onclick="vertex_distance_lock_first_vertex()">
            <div class="toggle__toggler toggler">
                <div class="toggler__knob"></div>
            </div>
        </label>
    </div>
</div>`;

export default defineComponent({
    props: {
        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    render() {
        return h(Dialog, {
            show: this.show,
            'onUpdate:show': () => this.$emit('update:show', false),
            id: 'vertexDistanceModal',
            title: 'Set distance',
            unload: false,
            onClose: () => this.$emit('update:show', false),
            confirm_label: 'Set',
            onConfirm: display_set_vertex_distance,
            width: 'narrower',
        }, () => h('div', { innerHTML: body }));
    }
});
